/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Orders_Single_Status_SuccessInputs */

const en_orders_single_status_success = /** @type {(inputs: Orders_Single_Status_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Order moved to ${i?.status}`)
};

const es_orders_single_status_success = /** @type {(inputs: Orders_Single_Status_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pedido movido a ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Order moved to {status}" |
*
* @param {Orders_Single_Status_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_single_status_success = /** @type {((inputs: Orders_Single_Status_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Single_Status_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_single_status_success(inputs)
	return es_orders_single_status_success(inputs)
});